module.exports = __webpack_public_path__ + "img/ppt.abf2674a.svg";